import { render, staticRenderFns } from "./card-vital-slider.vue?vue&type=template&id=2adc70fe&scoped=true&"
import script from "./card-vital-slider.vue?vue&type=script&lang=js&"
export * from "./card-vital-slider.vue?vue&type=script&lang=js&"
import style0 from "./card-vital-slider.vue?vue&type=style&index=0&id=2adc70fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2adc70fe",
  null
  
)

export default component.exports